<template>
  <div class="user-history-component" :style="{ width: '70%' }">
    <div class="title-container">
      <h2 class="title">Saved Pages</h2>
    </div>

    <div class="button-container">
      <router-link to="/Saved-Page/transactions" class="info-button">Transactions</router-link>
      <router-link to="/Saved-Page/submissions" class="info-button">Submissions</router-link>
      <router-link to="/Saved-Page/searches" class="info-button">Searches</router-link>
    </div>

    <div class="line-container">
      <hr class="line" />
    </div>

    <div class="info-container">
      
      <router-view>
        
        <div class="info-card" v-if="$route.path === '/Saved-Page/transactions'">
          <h3>Transactions Page</h3>
          <p>This is the content for the Transactions page.</p>
        </div>

        
        <div class="info-card" v-if="$route.path === '/Saved-Page/submissions'">
          <h3>Submissions Page</h3>
          <p>This is the content for the Submissions page.</p>
        </div>

       
        <div class="info-card" v-if="$route.path === '/Saved-Page/searches'">
          <h3>Searches Page</h3>
          <p>This is the content for the Searches page.</p>
        </div>
      </router-view>
    </div>
  </div>
</template>

  
  <style scoped>
  .user-history-component {
    width: 70%;
  }
  
  .title-container {
  display: flex;
  justify-content: flex-start;
}
  .title {
    margin-top: 1;
    
  }
  
  .line-container {
    position: relative;
  }
  
  .line {
    border: none;
  height: 4px;
  background-color: black;
  position: absolute;
 
  left: 0;
  right: 0;
  transform: translateY(-800%);
  z-index: 0;
  }
  
  .button-container {
    display: flex;
    justify-content: center;
    
  }
  
  .info-button {
    text-decoration: none;
    background-color: #f0f0f0; /* Grey background color */
    color: #333; /* Text color */
    padding: 8px 16px; /* Adjust padding as needed */
    border: 1px solid #ccc; /* Grey border */
 /* Adjust margin as needed */
    display: inline-block; /* Display as inline-block for button-like appearance */
    cursor: pointer; /* Cursor style */
  }
  .info-card {
    border: 1px solid #ccc; /* Grey border */
    border-radius: 5px; /* Rounded corners */
    margin-top: 10px; /* Adjust margin as needed */
    padding: 10px; /* Adjust padding as needed */
    background-color: #fff; /* White background color */
  }

  .info-button:visited {
    color: rgb(168, 164, 168); /* You can change this color to your preference */
  }
  
  .info-container {
    margin-top: 20px;
  }
  
  .info {
    margin: 0;
  }
  </style>
  